const API_ID = '2YsQBoyJACtUVArcysuh';
const API_BASE = 'https://us-central1-bookstore-api-e63c8.cloudfunctions.net/bookstoreApi';
const API_PATH = `${API_BASE}/apps/${API_ID}/books`;

export { API_ID, API_BASE, API_PATH };
